import { SxProps, Theme } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import React, { useState } from 'react';
import { Form } from '@/components/chord_progression/converter/Form';
import { Result } from '@/components/chord_progression/converter/Result';
import { Progression } from '@/components/chord_progression/converter/types';
import * as Key from '@/lib/key';

export type ConverterState = {
  progressionsString: string;
  predictedKeys: [string, number][];
  phraseKey: string;
};

export const Converter = (props: { sx?: SxProps<Theme> }) => {
  const [state, setState] = useState<ConverterState>({
    progressionsString: '',
    predictedKeys: [],
    phraseKey: '',
  });

  const handleProgressionsStringChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const progressionsString = e.target.value;
    const progressions = progressionsString.split(/[\t\s\n]/);
    const phraseKeys = Key.discriminateKey(progressions);

    setState({
      ...state,
      progressionsString: progressionsString,
      predictedKeys: phraseKeys,
      phraseKey: phraseKeys[0][0],
    });
  };

  const handleKeyChange = (e: SelectChangeEvent) => {
    setState({ ...state, phraseKey: e.target.value });
  };

  return (
    <Stack spacing={4} sx={{ ...props.sx, width: '100%' }}>
      <Form
        progressionsString={state.progressionsString}
        predictedKeys={state.predictedKeys}
        phraseKey={state.phraseKey}
        handleProgressionsStringChange={handleProgressionsStringChange}
        handleKeyChange={handleKeyChange}
      />
      {state.phraseKey && state.progressionsString ? (
        <Result
          phraseKey={state.phraseKey}
          alphabetProgressions={parseProgressionsString(
            state.progressionsString
          )}
        />
      ) : null}
    </Stack>
  );
};

const parseProgressionsString = (progressionsString: string): Progression[] => {
  const progressionStrings = progressionsString.split('\n');

  return progressionStrings.map((progressionString) => {
    if (progressionString === '') {
      return { type: 'blank', value: ['a'] };
    }

    // 1文字目がAからGまでの場合
    if (Key.keys.includes(progressionString.charAt(0))) {
      const chords = progressionString.split(/[\t\s]/).filter((value) => {
        return !!value;
      });

      return { type: 'chords', value: chords };
    }

    return { type: 'comment', value: [progressionString] };
  });
};
